module.exports = __webpack_public_path__ + "static/media/pokdeng.3d0e27d3.jpeg";